import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

import { useAuth } from "../context/AuthContext";
import { showError, showSuccess } from "../utils/toast"; // adjust path
import Header from "../components/Header";
import Footer from "../components/Footer";

const Login = () => {
  const [role, setRole] = useState("Customer");
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isOtpLogin, setIsOtpLogin] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [timer, setTimer] = useState(120);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const { login } = useAuth();
  const otpRefs = useRef([]);

  // Countdown timer for OTP
  useEffect(() => {
    let countdown;
    if (otpSent && timer > 0) {
      countdown = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(countdown);
  }, [otpSent, timer]);

  const handleOtpChange = (value, index) => {
    setError("");

    if (/^\d*$/.test(value)) {
      const updatedOtp = [...otp];
      updatedOtp[index] = value;
      setOtp(updatedOtp);

      // Auto move to next input if value entered
      if (value && index < 5) {
        otpRefs.current[index + 1].focus();
      }
      // Auto move to previous input on backspace
      if (!value && index > 0) {
        otpRefs.current[index - 1].focus();
      }
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!identifier || (!isOtpLogin && !password)) {
      showError("Please fill in all fields.");
      return;
    }

    if (isOtpLogin && otpSent) {
      // OTP verification
      const enteredOtp = otp.join("");
      if (enteredOtp) {
        //otp verification
        try {
          const res = await fetch(`${import.meta.env.VITE_API_URL}/api/otp-login`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              contactNumber: identifier,
              role: role,
              otp: enteredOtp
            }),
          });

          const data = await res.json();
          if (!res.ok) {
            showError(data.message || data.msg || "Login failed")
            navigate("/login")
            return;
          }
          localStorage.setItem("token", data.token);
          localStorage.setItem("user", JSON.stringify(data.user));
          localStorage.setItem("role", role);
          login({ ...data.user, role });
          navigate(role === "Agent" ? "/select-insurance" : "/customer/dashboard");
          showSuccess("Login Sucessfully")
        } catch (err) {
          console.error("❌ Error sending OTP:", err.message);
          showError(err.message);
        }
      } else {
        showError("Invalid OTP");
      }
    } else if (isOtpLogin) {
      // ✅OTP sending
      if (!identifier) {
        showError("Enter Phone to send OTP.");
        return;
      }
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/api/otp-login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            contactNumber: identifier,
            role: role
          }),
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.msg || "Failed to send OTP");
        setOtpSent(true);
        setTimer(120);
        showSuccess("OTP sent successfully!");
        console.log("✅ OTP Response:", data);
      } catch (err) {
        console.error("❌ Error sending OTP:", err.message);
        showError(err.message);
      }
      ////
    } else {
      // ✅ Password login via API
      try {
        const res = await fetch(`${import.meta.env.VITE_API_URL}/api/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ identifier, password, role }),
        });
        const data = await res.json();
        if (!res.ok) {
          return showError(data.msg || "Login failed")
          //  setError(data.msg || "Login failed")
        };

        localStorage.setItem("token", data.token)
        localStorage.setItem("user", JSON.stringify(data.user));
        login({ ...data.user, role });
        showSuccess("Login Sucessfully")
        navigate(role === "Agent" ? "/select-insurance" : "/customer/dashboard");
      } catch {
        showError("Login failed");
      }
    }
  };

  const handleReSendOTP = async () => {
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/api/otp-login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          contactNumber: identifier,
          role: role
        }),
      });

      const data = await response.json();
      if (!response.ok) showError(data.message || data.msg || "Failed to send OTP");
      setOtpSent(true)
      showSuccess("OTP Resent successfully!");
      console.log("✅ OTP Response:", data);
    } catch (err) {
      console.error("❌ Error sending OTP:", err.message);
      showError(err.message);
    }
  };


  return (
    <>
    <Header/>
    <div className='over-nav' style={{height:'100px',background:'#0b7285'}}></div>
    <div className="login-page">
      <div className="login-card">
        <div className="logo-section">
          {/* Header layout: Icon (Left) -> Text (Right) */}
          <div className="panel-header" style={{display:"flex", justifyContent:"center", alignItems:"flex-start", gap:"32px"}}>
            <Link to="/" className="home-btn" title="Back to Home"  style={{ marginTop:"14px", fontSize:"30px",textDecoration:"none"}}>
              <i class="fa fa-arrow-left"></i>
            </Link>
            <div>
            <h2 style={{ marginRight:"64px", marginBottom:"0px"}}>Insurance Panel</h2>
          <p style={{ marginRight:"64px"}}>Secure access to your account</p>
            </div>
          </div>
        </div>

        {/* Role Toggle */}
        <div className="role-toggle">
          <button className={role === "Customer" ? "active" : ""} onClick={() => setRole("Customer")}>
            Customer
          </button>
          <button className={role === "Agent" ? "active" : ""} onClick={() => setRole("Agent")}>
            Agent
          </button>
        </div>

        {error && <p className="error">{error}</p>}

        <form onSubmit={handleLogin}>
          {!otpSent ? (
            <>
              <label>Email / Phone Number</label>
              <input
                type="text"
                placeholder="Enter email or phone"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
              />

              {!isOtpLogin && (
                <>
                  <label>Password</label>
                  <div className="password-field">
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span onClick={() => setShowPassword(!showPassword)} className="toggle-eye">

                    </span>
                  </div>
                </>
              )}

              <div className="login-options">
                <label>
                  <input type="checkbox" /> Remember this device
                </label>
                <span className="otp-link" onClick={() => setIsOtpLogin(!isOtpLogin)}>
                  {isOtpLogin ? "Back to Password Login" : "Login via OTP"}
                </span>
              </div>

              <button type="submit" className="login-btn"
              >
                {isOtpLogin ? "Send OTP" : "Login"}
              </button>
            </>
          ) : (
            <>
              <h4>Verify Your {identifier.includes("@") ? "Email" : "Mobile Number"}</h4>
              <p>A 6-digit code has been sent to <b>{identifier}</b></p>
              <div className="otp-inputs">
                {otp.map((digit, idx) => (
                  <input
                    key={idx}
                    maxLength="1"
                    ref={(el) => (otpRefs.current[idx] = el)}
                    value={digit}
                    onChange={(e) => handleOtpChange(e.target.value, idx)}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" && !otp[idx] && idx > 0) {
                        otpRefs.current[idx - 1].focus();
                      }
                    }}
                  />
                ))}
              </div>
              <p className="timer">
                OTP will expire in{" "}
                <span>
                  {Math.floor(timer / 60)}:{String(timer % 60).padStart(2, "0")}
                </span>
              </p>
              <p className="resend-links">
                <span onClick={() => {
                  handleReSendOTP();
                }}>
                  Resend
                </span> | <span>Send to alternate</span>
              </p>
              <button type="submit" className="login-btn">
                Verify
              </button>
              <p className="back-link" onClick={() => setOtpSent(false)}>← Back to password login</p>
            </>
          )}
        </form>
        <p className="register-link">
          Create an account? <Link to="/register">Register Now</Link>
        </p>
      </div>

    </div>
    <Footer/>
    </>
  );
};

export default Login;